import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import FileItem from 'components/FileItem';

var Block = /*#__PURE__*/function (_Component) {
  _inherits(Block, _Component);

  var _super = _createSuper(Block);

  function Block() {
    var _this;

    _classCallCheck(this, Block);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          headerContent = _this$props.headerContent,
          content = _this$props.content,
          time = _this$props.time,
          footerContent = _this$props.footerContent,
          image = _this$props.image;
      return /*#__PURE__*/React.createElement("div", null, headerContent ? /*#__PURE__*/React.createElement("div", {
        className: "block-header"
      }, headerContent) : null, image != null ? /*#__PURE__*/React.createElement(FileItem, {
        file: image,
        element: "div",
        className: "block-image"
      }) : null, time ? /*#__PURE__*/React.createElement("div", {
        className: "block-time"
      }, time) : null, content ? /*#__PURE__*/React.createElement("div", {
        className: "block-content"
      }, content) : null, footerContent ? /*#__PURE__*/React.createElement("div", {
        className: "block-footer"
      }, footerContent) : null, children ? children : null);
    });

    return _this;
  }

  _createClass(Block, [{
    key: "render",
    value: function render() {
      var link = this.props.link;
      return /*#__PURE__*/React.createElement("div", {
        className: "block-container",
        style: this.props.style
      }, link != null ? /*#__PURE__*/React.createElement(Link, {
        to: link
      }, this.renderContent()) : this.renderContent());
    }
  }]);

  return Block;
}(Component);

export var BlockWrapper = function BlockWrapper(props) {
  var columns = false;

  if (props.columns) {
    columns = props.columns;
  } else if (props.cols) {
    columns = props.cols;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "block-wrapper ".concat(columns ? 'cols-' + columns : null),
    style: props.style
  }, props.children ? props.children : null);
};
export var BlockHeader = function BlockHeader(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "block-header",
    style: props.style
  }, props.children ? /*#__PURE__*/React.createElement("h3", null, props.children) : null);
};
export var BlockContent = function BlockContent(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "block-content",
    style: props.style
  }, props.children ? props.children : null);
};
export var BlockFooter = function BlockFooter(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "block-footer",
    style: props.style
  }, props.children ? props.children : null);
};
export var BlockTime = function BlockTime(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "block-time",
    style: props.style
  }, props.children ? props.children : null);
};
export default Block;